module.exports = __webpack_public_path__ + "img/lighthouse-travel-poster.403954a0.jpg";